const tabs = () => (
  [ACCOUNTS, CARDS, TRANSACTIONS, ENVELOPES]
)

export default {
  get tabs() { return tabs() }
}

const ACCOUNTS = {
  label: 'Accounts',
  href: { params: { page: 'Programs', section: '>Card', action: undefined } }
}

const CARDS = {
  label: 'Cards',
  href: { params: { page: 'Programs', section: '>Card', action: 'cards' } }
}

const TRANSACTIONS = {
  label: 'Transactions',
  href: { params: { page: 'Programs', section: '>Card', action: 'transactions' } }
}

const ENVELOPES = {
  label: 'Envelopes',
  href: { params: { page: 'Programs', section: '>Card', action: 'envelopes' } }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-accounts/tabs.js